/*
 *
 * DashboardContainer reducer
 *
 */
import produce from 'immer';

import { APPROVED } from 'utils/constants';

import {
  DEFAULT_ACTION,
  UPDATE_MENU_SELECTED,
  UPDATE_PG_DASHBOARD_STATUS_DATA,
  ENABLE_LOADER,
  UPDATE_STATUS,
  SAVE_MERCHANT_DETAIL_RESPONSE,
  DISABLE_LOADER,
  UPDATE_SUBSCRIPTION_STATUS,
  ACTIVE,
  COHORT_LIST_DATA_SUCCESS,
  UPDATE_LOADER_FOR_DASHBOARD,
} from './constants';
import { UPDATE_GAMMA_TOKEN } from '../LandingPage/constants';

export const initialState = {
  merchantDetails: {},
  merchantName: 'Your Merchant Name',
  menuSelected: 'TRANSACTIONS',
  pgStatus: '',
  userType: '',
  mkpSettlementsStatus: '',
  baasStatus: '',
  isLoading: false,
  subscriptionsConfig: {},
  cohortList: [],
  dashboardContainerLoaders: {},
};

/* eslint-disable default-case, no-param-reassign */
const dashboardContainerReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case UPDATE_MENU_SELECTED: {
        draft.menuSelected = action.data;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case UPDATE_LOADER_FOR_DASHBOARD: {
        draft.dashboardContainerLoaders = {
          ...draft.dashboardContainerLoaders,
          ...action.data,
        };
        break;
      }
      case UPDATE_PG_DASHBOARD_STATUS_DATA: {
        const { response, isTestEnv } = action.data;

        const [validateTokenResponse = {}, productStatus = {}] = response;

        if (validateTokenResponse.merchantId)
          localStorage.setItem('merchantId', validateTokenResponse.merchantId);
        if (validateTokenResponse.userId)
          localStorage.setItem('userId', validateTokenResponse.userId);
        localStorage.setItem(
          'loggedInAsPartner',
          validateTokenResponse.loggedInAsPartner,
        );

        localStorage.setItem(
          'eposStatus',
          isTestEnv ? APPROVED : productStatus.EPOS,
        );
        draft.userType = validateTokenResponse?.userType;
        draft.pgStatus = isTestEnv ? APPROVED : productStatus.PG;
        draft.mkpSettlementsStatus = productStatus.CES;
        draft.baasStatus = productStatus.BAAS;
        draft.isLoading = false;
        break;
      }
      case UPDATE_STATUS: {
        const isPGApproved = action.data;
        draft.pgStatus = isPGApproved ? APPROVED : '';
        break;
      }
      case SAVE_MERCHANT_DETAIL_RESPONSE: {
        const { data } = action;
        draft.merchantDetails = {
          ...data,
          name: data.merchantName,
        };
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case UPDATE_SUBSCRIPTION_STATUS: {
        const { status } = action.data;
        draft.subscriptionsConfig = { ...action.data, configLoaded: true };
        if (status === ACTIVE) {
          localStorage.setItem('subscriptionEnabled', true);
        } else localStorage.setItem('subscriptionEnabled', '');
        break;
      }
      case COHORT_LIST_DATA_SUCCESS: {
        if (action.payload.cohorts) {
          draft.cohortList = action.payload.cohorts;
        }
        break;
      }
      case UPDATE_GAMMA_TOKEN: {
        try {
          const { token } = action.data;
          const cfTokenObj = JSON.parse(localStorage.getItem('cfToken'));
          cfTokenObj.test = { token };
          localStorage.setItem('gammaToken', token);
          localStorage.setItem('cfToken', JSON.stringify(cfTokenObj));
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default dashboardContainerReducer;
